import { create } from 'zustand';

interface RolePreviewState {
  previewRoleId: string | null;
  previewRoleName: string | null;
  setPreviewRole: (id: string, name: string) => void;
  clearPreviewRole: () => void;
}

export const useRolePreviewStore = create<RolePreviewState>((set) => ({
  previewRoleId: null,
  previewRoleName: null,
  setPreviewRole: (id, name) => set({ previewRoleId: id, previewRoleName: name }),
  clearPreviewRole: () => set({ previewRoleId: null, previewRoleName: null }),
}));
